export const standardConfigOptions = () => {
    return {
        天鹅: [
            {
                label: "主机",
                value: "主机",
                val: 0,
                searchVal: "host",
            },
            {
                label: "电源配置器",
                value: "电源配置器",
                val: 0,
                searchVal: "aCAdapter",
            },
            {
                label: "模拟眼",
                value: "模拟眼",
                val: 0,
                searchVal: "modelEye",
            },
            {
                label: "下巴托纸(含钉)",
                value: "下巴托纸(含钉)",
                val: 0,
                searchVal: "chinSupportPaper",
            },
            {
                label: "遮光罩",
                value: "遮光罩",
                val: 0,
                searchVal: "lensHood",
            },
            {
                label: "防尘罩",
                value: "防尘罩",
                val: 0,
                searchVal: "dustCover",
            },
            {
                label: "使用说明书",
                value: "使用说明书",
                val: 0,
                searchVal: "operationInstructions",
            },
            {
                label: "保修卡",
                value: "保修卡",
                val: 0,
                searchVal: "warrantyCard",
            },
            {
                label: "产品合格证",
                value: "产品合格证",
                val: 0,
                searchVal: "productCertificate",
            },
            {
                label: "售后服务承诺书",
                value: "售后服务承诺书",
                val: 0,
                searchVal: "letterOfCommitment",
            },
            {
                label: "包材",
                value: "包材",
                val: 0,
                searchVal: "packagingMaterials",
            },
            {
                label: "包装清单",
                value: "包装清单",
                val: 0,
                searchVal: "packingList",
            },
            {
                label: "700*550 升降台",
                value: "700*550 升降台",
                val: 0,
                searchVal: "smallLiftingTable",
            },
            {
                label: "A4 打印机（黑白）",
                value: "A4 打印机（黑白）",
                val: 0,
                searchVal: "blackAndWhitePrinter",
            },
        ],
        天鸽: [
            {
                label: "主机",
                value: "主机",
                val: 0,
                searchVal: "host",
            },
            {
                label: "电源适配器",
                value: "电源适配器",
                val: 0,
                searchVal: "aCAdapter",
            },
            {
                label: "便携包",
                value: "便携包",
                val: 0,
                searchVal: "portableBag",
            },
            {
                label: "使用说明书",
                value: "使用说明书",
                val: 0,
                searchVal: "operationInstructions",
            },
            {
                label: "产品合格证",
                value: "产品合格证",
                val: 0,
                searchVal: "productCertificate",
            },
            {
                label: "保修卡",
                value: "保修卡",
                val: 0,
                searchVal: "warrantyCard",
            },
            {
                label: "腕带",
                value: "腕带",
                val: 0,
                searchVal: "wristStrap",
            },
            {
                label: "背带",
                value: "背带",
                val: 0,
                searchVal: "straps",
            },
            {
                label: "售后服务承诺书",
                value: "售后服务承诺书",
                val: 0,
                searchVal: "letterOfCommitment",
            },
            {
                label: "装箱单",
                value: "装箱单",
                val: 0,
                searchVal: "packingList",
            },
            {
                label: "热敏打印机",
                value: "热敏打印机",
                val: 0,
                searchVal: "thermalPrinter",
            },
            {
                label: "销售安装签收表",
                value: "销售安装签收表",
                val: 0,
                searchVal: "salesInstallationReceiptForm",
            },
        ],
    }
};

export const optionalOptions = () => {
    return {
        天鹅: [
            {
                label: "儿童拖",
                value: "儿童拖",
                val: 0,
                searchVal: "childCare",
            },
            {
                label: "运输箱( 航空箱 )",
                value: "运输箱( 航空箱 )",
                val: 0,
                searchVal: "transportBox",
            },
            {
                label: "热敏打印机",
                value: "热敏打印机",
                val: 0,
                searchVal: "thermalPrinter",
            },
            {
                label: "1000*550升降台",
                value: "1000*550升降台",
                val: 0,
                searchVal: "largeLiftingTable",
            },
            {
                label: "一体机(含线材)",
                value: "一体机(含线材)",
                val: 0,
                searchVal: "integratedMachine",
            },
            {
                label: "拓展屏(含线材)",
                value: "拓展屏(含线材)",
                val: 0,
                searchVal: "expansionScreen",
            },
            {
                label: "A4打印机(彩色)",
                value: "A4打印机(彩色)",
                val: 0,
                searchVal: "colorPrinter",
            },
        ],
        天鸽: [
            {
                label: "扫描枪",
                value: "扫描枪",
                val: 0,
                searchVal: "scanningGun",
            },
            {
                label: "视筛箱(编号）",
                value: "视筛箱(编号）",
                val: 0,
                searchVal: "visualScreenBox",
            },
        ],
    }
};
